export const EVENTS = {
  changeClip: 'ChangeClip',
  episodeListen: 'EpisodeListen',
  episodePageLoaded: 'EpisodePageLoaded',
  homePageLoaded: 'HomePageLoaded',
  homeFeedStartDiscovering: 'HomeFeedStartDiscovering',
  pauseEpisode: 'PauseEpisode',
  playEpisode: 'PlayEpisode',
  playingEpisode: 'StreamEpisode',
  podcastPageLoaded: 'PodcastPageLoaded',
  toggleClipSound: 'ToggleClipSound',
  searchBarExpanded: 'SearchBarExpanded',
  searchResultSelected: 'SearchResultSelected',
  searchTrendingSelected: 'SearchTrendingSelected',
  skip: 'SkipThroughEpisode',
  shareEpisode: 'SharePodcastEpisode',
  sharePodcast: 'SharePodcast',
  signUp: 'CompleteSignUp',
  login: 'LogIn',
  promotePodcast: 'PromoteYourPodcast',
  followPodcast: 'FollowPodcast',
  unfollowPodcast: 'UnfollowPodcast',
  claimPodcastEmailCTA: 'ClaimPodcastEmailCTA',
  ownershipRequestEmailCTA: 'OwnershipRequestEmailCTA',
  ownershipGrantedEmailCTA: 'OwnershipGrantedEmailCTA',
  displayFollowPrompt: 'DisplayFollowPrompt',
  visitPodcatcher: 'VisitPodcatcher',
  episodeComplete: 'EpisodeComplete',
  clickBlockedEpisodeCard: 'ClickBlockedEpisodeCard',
  episodePageBlockedStateCTA: 'EpisodePageBlockedStateCTA',
  clickEpisodeCard: 'ClickEpisodeCard',
  persistentPlayerLink: 'PersistentPlayerLink',
  sponsoredResultsModalCTA: 'SponsoredResultsModalCTA',
  viewPodcastAnalytics: 'ViewPodcastAnalytics',
  tldlEmptyStateButtons: 'TLDLEmptyStateButtons',
  tldlSummarizeEpisodes: 'TLDLSummarizeEpisodes',
  tldlAudioReady: 'TLDLAudioReady',
  playTldlAudio: 'PlayTLDLAudio',
  tldlVisitFullEpisode: 'TLDLVisitFullEpisode',
  tldlShareButton: 'TLDLShareButton',
  tldlSummarizeMore: 'TLDLSummarizeMore',
  clickTldlBanner: 'ClickTLDLBanner',
} as const;
